<template>
  <v-container
    id="data-management"
    tag="section"
  >
    <base-resource-grid
      color="red darken-4"
      icon="mdi-cup-outline"
      plural-name="Platforms"
      singular-name="Platform"
      allow-expand
      :headers="headers"
      :resource="platformResource"
      :actions="actions"
      @handleAction="handleAction"
    >
      <template v-slot:editForm="bindings">
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.platform"
              :error-messages="bindings.formErrors.Platform"
              label="Platform"
            />
          </v-col>
        </v-row>
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="platformHistory/"
      id-field="platformId"
      title-field="platform"
      color="red darken-4"
      :columns="headers"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'Platforms',

    data: () => ({
      headers: [
        {
          text: 'Platform',
          value: 'platform',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      platformResource: new TroodyApi('platform/'),

      historyItem: null,
    }),

    methods: {
      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },
    },
  }
</script>
